












import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { Product } from '~/modules/catalog/product/types';
import { useProductStore } from '~/modules/catalog/stores/product';

export default defineComponent({
  name: 'ProductTabs',
  components: {
    Included: () => import('~/modules/catalog/product/components/tabs/tab-types/Included.vue'),
    WeightDimensions: () => import('~/modules/catalog/product/components/tabs/tab-types/WeightDimensions.vue'),
    Specifications: () => import('~/modules/catalog/product/components/tabs/tab-types/Specifications.vue'),
    Description: () => import('~/modules/catalog/product/components/tabs/tab-types/Description.vue'),
    ShippingBox: () => import('~/modules/catalog/product/components/tabs/tab-types/ShippingBox.vue'),
    Assembly: () => import('~/modules/catalog/product/components/tabs/tab-types/Assembly.vue'),
    // Reviews: () => import('~/modules/catalog/product/components/tabs/tab-types/Reviews.vue'),
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup() {
    const { tabs } = useProductStore();

    return {
      tabs,
    };
  },
});
